import { TaskCategoryItem } from '../types/Task';

export const getTopLevelCategories = (categories: TaskCategoryItem[]): TaskCategoryItem[] =>
  categories.filter(category => !category.parentCategoryId);

export const getSubcategories = (categories: TaskCategoryItem[], parentCategoryId: string): TaskCategoryItem[] =>
  categories
    .filter(category => category.parentCategoryId === parentCategoryId)
    .sort((left, right) => left.name.localeCompare(right.name));

export const formatCategoryLabel = (
  category: Pick<TaskCategoryItem, 'id' | 'name' | 'parentCategoryId'>,
  categories: TaskCategoryItem[]
): string => {
  if (!category.parentCategoryId) {
    return category.name;
  }

  const parent = categories.find(item => item.id === category.parentCategoryId);
  return parent ? `${parent.name} › ${category.name}` : category.name;
};

export type CategorySelectOption = {
  id: string;
  label: string;
  isSubcategory: boolean;
};

export const buildCategorySelectOptions = (categories: TaskCategoryItem[]): CategorySelectOption[] => {
  const topLevel = getTopLevelCategories(categories).sort((left, right) => left.name.localeCompare(right.name));
  const options: CategorySelectOption[] = [];

  topLevel.forEach(parent => {
    options.push({ id: parent.id, label: parent.name, isSubcategory: false });
    getSubcategories(categories, parent.id).forEach(child => {
      options.push({
        id: child.id,
        label: `${parent.name} › ${child.name}`,
        isSubcategory: true,
      });
    });
  });

  return options;
};

export type CategoryListRow = {
  category: TaskCategoryItem;
  depth: number;
  canAddSubcategory: boolean;
};

export const buildCategoryListRows = (categories: TaskCategoryItem[]): CategoryListRow[] => {
  const topLevel = getTopLevelCategories(categories).sort((left, right) => left.name.localeCompare(right.name));
  const rows: CategoryListRow[] = [];

  topLevel.forEach(parent => {
    rows.push({
      category: parent,
      depth: 0,
      canAddSubcategory: true,
    });

    getSubcategories(categories, parent.id).forEach(child => {
      rows.push({
        category: child,
        depth: 1,
        canAddSubcategory: false,
      });
    });
  });

  return rows;
};
